module.exports = __webpack_public_path__ + "img/t_0026.a25ffa97.gif";